import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { fromHomeAddressActions } from '../actions';
import { IEmployeeDetailRequest } from '../models/employee-detail.model';
import { IHomeAddressResponse } from '../models/home-address.model';

export const homeAddressCurrentFeatureKey = 'homeAddressCurrent';

export interface HomeAddressState {
  homeAddressCurrentRequest: string;
  homeAddressCurrentResponse: IHomeAddressResponse;
  homeAddressCurrentFailure: IGenericError<ErrorResponse>;
}

export const initialState: HomeAddressState = {
  homeAddressCurrentRequest: undefined,
  homeAddressCurrentResponse: undefined,
  homeAddressCurrentFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromHomeAddressActions.loadHomeAddresss, (state, action) => ({
    ...state,
    homeAddressCurrentRequest: action.request
  })),
  on(fromHomeAddressActions.loadHomeAddresssSuccess, (state, action) => ({
    ...state,
    homeAddressCurrentResponse: action.response
  })),
  on(fromHomeAddressActions.loadHomeAddresssFailure, (state, action) => ({
    ...state,
    homeAddressCurrentFailure: action.error
  }))
);

export const getHomeAddressRequest = (state: HomeAddressState) => state.homeAddressCurrentRequest;
export const getHomeAddressResponse = (state: HomeAddressState) => {
  return state.homeAddressCurrentResponse;
};
export const getHomeAddressFailure = (state: HomeAddressState) => state.homeAddressCurrentFailure;
